export default __webpack_public_path__ + "static/media/bg2.967f0cb3.png";